import React from 'react'
import Text from '../../../components/text/Text'
import routes from '../../../router/routes'
import './BillingScreen.css'
import { useNavigate } from 'react-router-dom'
import arrowRight from '../../../assets/icons/icons-long-right-arrow.png'
import { track } from '../../../ClevertapWrapper'
import { clevertapEvents } from '../../../labels'
import { format } from 'date-fns'
import { isAdmin } from '../../../Utils/Profile'

export default function BillingScreen() {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const billingEventParms = {
        pageName: 'BillingScreen',
        pageURL: routes.billing,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const navigation = useNavigate()

    interface ListItem {
        id: number
        text: string
        icon: string
        description: string
        onClick?: () => void
        hide?: boolean
    }

    const requestProformaNavigation = () => {
        navigation(`${routes.requestProforma}`)
        track(
            clevertapEvents.amiposweb_administratunegocio_facturacionypagos_movimientosnofacturados,
            billingEventParms
        )
    }
    const billingHistoryNavigation = () => {
        navigation(`${routes.billingMain}`)
        track(
            clevertapEvents.amiposweb_administratunegocio_facturacionypagos_historicofacturacion,
            billingEventParms
        )
    }

    const requestBillingDataNavigation = () => {
        navigation(`/${routes.billing}/data`)
        track(
            clevertapEvents.amiposweb_administratunegocio_facturacionypagos_datosfacturacion,
            billingEventParms
        )
    }

    const requestPaymentDataNavigation = () => {
        navigation(`/${routes.billing}/payment/data`)
        track(
            clevertapEvents.amiposweb_administratunegocio_facturacionypagos_datosdepago,
            billingEventParms
        )
    }

    const firstButtonData: ListItem[] = [
        {
            id: 1,
            icon: require('./../../../assets/icons/icons-file.png'),
            text: 'DATOS DE FACTURACIÓN',
            description:
                'Revisa los datos que amiPASS utilizará para\nfacturar tu comisión por los servicios\nprestados.',
            onClick: requestBillingDataNavigation,
            hide: !isAdmin(),
        },

        {
            id: 2,
            icon: require('./../../../assets/icons/icons-file-history.png'),
            text: 'HISTÓRICO DE FACTURACIÓN',
            description:
                'Ten acceso a tus historicos de facturas\ncuando quieras.',
            onClick: billingHistoryNavigation,
            hide: !isAdmin(),
        },
    ]

    const secondButtonData: ListItem[] = [
        {
            id: 3,
            icon: require('./../../../assets/icons/icons-ticket.png'),
            text: 'DATOS DE PAGO',
            description:
                'Revisa los datos que amiPASS utilizará\npara realizar el pago de mi factura.',
            onClick: requestPaymentDataNavigation,
            hide: !isAdmin(),
        },
        {
            id: 4,
            icon: require('./../../../assets/icons/icons-file-history.png'),
            text: 'MOVIMIENTOS NO FACTURADOS. ',
            description:
                'Ten acceso a mis movimientos no facturados\npara solicitar pro-forma antes del cierre oficial\ndefinido para tu local.',
            onClick: requestProformaNavigation,
            hide: false,
        },
    ]

    return (
        <div className="billing-screen-container">
            <Text
                label="Facturación y pagos"
                fontWeight={600}
                color={'#656565'}
                fontSize={20}
            />
            <div className="flex-direction">
                <div className="billing-buttons-wrapper">
                    {firstButtonData.map((item) => (
                        <>
                            {item.hide ? (
                                <></>
                            ) : (
                                <div
                                    className="billing-button-container"
                                    key={`${item.id}${item.text}`}
                                    onClick={item.onClick}
                                >
                                    <div className="flex-direction">
                                        <div>
                                            <img
                                                className="billing-icon"
                                                src={item.icon}
                                                alt={item.icon}
                                            />
                                        </div>
                                        <div className="carousel-title">
                                            <Text
                                                label={item.text}
                                                fontSize={14}
                                                fontWeight={600}
                                                color={'#656565'}
                                                lineHeight={3}
                                            />
                                        </div>
                                    </div>
                                    <div className="height" />
                                    <div>
                                        <Text
                                            label={item.description}
                                            fontSize={14}
                                            fontWeight={400}
                                            color={'#656565'}
                                        />
                                    </div>
                                    <div className="height" />
                                    <div
                                        className="flex-direction"
                                        style={{ alignItems: 'center' }}
                                    >
                                        <Text
                                            label={'IR'}
                                            fontSize={16}
                                            fontWeight={700}
                                            color={'#656565'}
                                        />
                                        <img
                                            src={arrowRight}
                                            className="arrow-right"
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    ))}
                </div>

                <div className="billing-buttons-wrapper">
                    {secondButtonData.map((item, index) => (
                        <>
                            {item.hide ? (
                                <></>
                            ) : (
                                <div
                                    className="billing-button-container"
                                    key={index}
                                    onClick={item.onClick}
                                >
                                    <div className="flex-direction">
                                        <div>
                                            <img
                                                className="billing-icon"
                                                src={item.icon}
                                                alt={item.icon}
                                            />
                                        </div>
                                        <div className="carousel-title">
                                            <Text
                                                label={item.text}
                                                fontSize={14}
                                                fontWeight={600}
                                                color={'#656565'}
                                            />
                                        </div>
                                    </div>
                                    <div className="height" />
                                    <div>
                                        <Text
                                            label={item.description}
                                            fontSize={14}
                                            fontWeight={400}
                                            color={'#656565'}
                                            marginRight={10}
                                        />
                                    </div>
                                    <div className="height" />
                                    <div
                                        className="flex-direction"
                                        style={{ alignItems: 'center' }}
                                    >
                                        <Text
                                            label={'IR'}
                                            fontSize={16}
                                            fontWeight={700}
                                            color={'#656565'}
                                        />
                                        <img
                                            src={arrowRight}
                                            className="arrow-right"
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    ))}
                </div>
            </div>
        </div>
    )
}
